var map = {
	"./1.26 FOTO 1.jpg": 802,
	"./1.28 FOTO 3.png": 803,
	"./3.1 KC Tribunj 1-14.08.2025. – kopija.png": 804,
	"./3.1 KC Tribunj 1-14.08.2025..png": 805,
	"./3.2 KC Tribunj 2-14.08.2025..png": 806,
	"./3.3 KC Tribunj 3-14.08.2025..png": 807,
	"./3.4 KC Tribunj 4-14.08.2025.JPG": 808,
	"./3.5 KC Tribunj 5-14.08.2025.JPG": 809,
	"./3.6 KC Tribunj 6-14.08.2025.jpg": 810,
	"./3.7 KC Tribunj 7-14.08.2025.jpg": 811,
	"./FOTO 3.1.png": 812,
	"./FOTO 3.5.jpg": 813,
	"./FOTO 3.6.png": 814,
	"./FOTO 3.7.jpg": 815,
	"./FOTO 3.8.jpg": 816,
	"./FOTO 3.9.jpg": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;